<template>
  <BInputGroup>
    <BFormInput ref="input"
                type="text"
                v-bind="$attrs"
                :size="small ? 'sm' : undefined"
                class="removeMSClear"
                :class="{ 'p-1': small }"
                :model-value="value"
                @update:model-value="onInput"
                @blur="onBlur"
                @keyup="onKeyUp">
                <!-- @change="onChange" @blur="onBlur" -->
    </BFormInput>

    <template #append>
      <BButton ref="closeButton"
               :size="small ? 'sm' : undefined"
               :variant="hasValue ? 'primary' : 'outline-secondary'"
               :disabled="!hasValue"
               @click="clearValue"
               @blur="onBlur">
        <font-awesome-icon icon="times" />
      </BButton>
    </template>
  </BInputGroup>
</template>

<script>
export default {
  name: "SearchInput",

  emits: ['input', 'change'], // Behalte die ursprünglichen Events

  props: {
    value: {  // Behalte die ursprüngliche prop
      type: String,
      default: null
    },
    small: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    hasValue() {
      return this.value !== undefined &&
             this.value !== null &&
             this.value !== '';
    }
  },

  methods: {
    // Check if input or button controls are currently focused
    hasFocus() {
      const inputEl = this.$refs.input;
      const buttonEl = this.$refs.closeButton;

      return document.activeElement === inputEl ||
             document.activeElement === buttonEl;
    },

    // Fire input event (behält die ursprüngliche API)
    onInput(value) {
      this.$emit('input', value);
    },

    onKeyUp(e) {
      // Fire change event when Enter is pressed
      if (e.key === 'Enter') {
        const value = e.target.value;
        this.$emit('change', value);
      }
    },

    // Fire change event only when control has focus
    onChange(event) {
      const value = event.target ? event.target.value : event;
      if (this.hasFocus()) this.$emit('change', value);
    },

    // Fire change event when control loses focus
    onBlur(event) {
      const value = event.target ? event.target.value : event;
      this.$emit('change', value);
    },

    // Clears the current value
    clearValue() {
      const inputEl = this.$refs.input;
      if (inputEl) {
        inputEl.focus();
      }

      this.$emit('input', null);
      this.$emit('change', null);
    }
  }
}
</script>

<style scoped>
/* Remove clear button on IE11 */
.removeMSClear::-ms-clear {
  display: none;
}
</style>
